module.exports = __webpack_public_path__ + "packs/media/images/pic05-3fbdbd1f7c6d7d0773357ea64f0bab6a.jpg";